function numberFormat (x, locale = 'uk') {
    let loc = locale == 'uk' ? 'uk-UA' : 'en-GB';

    const options = {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 0, // Set this to the number of decimal places you want
    };

    // Ensure x is a number
    const number = Number(x);

    // Handle invalid values
    if (isNaN(number)) {
        return x;
    }

    return new Intl.NumberFormat(loc, options).format(number);
}

module.exports = numberFormat;
